module.exports = __webpack_public_path__ + "img/img.b41bc3a5.jpg";